import { cloneDeep } from "lodash";
import { Row, Col } from "reactstrap";
import React, { useEffect, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import AttributeCard from "../attribute-card";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeStartProperty({ node, nodeChange, dependencies }) {
  const [attributes, setAttributes] = useState([]);
  useEffect(() => {
    if (node.properties.args && node.properties.args.inputData)
      setAttributes(
        Object.entries(node.properties.args.inputData).map(([key, value]) => ({
          name: key,
          type: value.type,
          required: value.required,
          inputType: value.type === "model" ? "model" : "native"
        }))
      );
  }, [node]);
  const onUpdateAttributes = (att, index) => {
    const tmp = cloneDeep(attributes);
    if (att.inputType === "model") {
      att.name = att.type;
    }
    tmp[index] = att;
    setAttributes(tmp);
  };
  const addAttribute = att => {
    const tmp = cloneDeep(attributes);
    if (att.inputType === "model") {
      // por ahora solo soportara atributos nativos
      const modelAttributes = dependencies
        .getModels()
        .models.find(o => o.name === att.type)
        .attributes.map(o => ({
          name: o.name,
          type: o.type,
          required: att.required,
          inputType: "native"
        }));
      modelAttributes.forEach(o => {
        tmp.push(o);
      });
    } else {
      tmp.push(att);
    }
    setAttributes(tmp);
  };
  const onDeleteAttribute = index => {
    const tmp = cloneDeep(attributes);
    tmp.splice(index, 1);
    setAttributes(tmp);
  };
  const onSubmit = name => {
    const tmpNode = cloneDeep(node);
    tmpNode.properties.name = name;
    tmpNode.properties.args.inputData = Object.fromEntries(
      attributes.map(o => [
        [o.name],
        {
          type: o.inputType === "model" ? "model" : o.type,
          required: o.required
        }
      ])
    );
    nodeChange(tmpNode);
  };
  return (
    <>
      <Row>
        <Col xs="12">
          <NodeNameValidation
            label={t("modalPropiedadesLabelNodoValidacionNombre")}
            feedback={t("modalPropiedadesFeedbackValidacionNombre")}
            nodesNames={dependencies.nodeNames}
            oldName={node.properties.name}
            onSubmit={onSubmit}
          />
        </Col>
        <Col xs="12">
          <AttributeCard
            formTitle={t("modalPropiedadesInicioTitulo")}
            resultsTitle={t("modalPropiedadesInicioListado")}
            attributes={attributes}
            updateAttribute={onUpdateAttributes}
            addAttribute={addAttribute}
            deleteAttribute={onDeleteAttribute}
            columns={[
              {
                name: "Entrada",
                label: t("modalPropiedadesInicioEntrada"),
                key: "inputType",
                type: "select",
                options: { Modelo: "model", Nativo: "native" },
                required: true,
                columnVisible: false,
                cols: 2,
                tooltip: (
                  <HelpTooltip
                    msg={t("modalPropiedadesInicioEntradaTooltip")}
                  />
                )
              },
              {
                name: "Nombre",
                label: t("modalPropiedadesInicioNombre"),
                key: "name",
                type: "text",
                required: true,
                dependence: "inputType",
                visible: { model: false, native: true },
                cols: 3,
                tooltip: (
                  <HelpTooltip msg={t("modalPropiedadesInicioNombreTooltip")} />
                )
              },
              {
                name: "Tipo",
                label: t("modalPropiedadesInicioTipo"),
                key: "type",
                type: "select",
                options: {
                  model: Object.fromEntries(
                    dependencies.getModels().models.map(o => [o.name, o.name])
                  ),
                  native: {
                    string: "String",
                    int: "Int",
                    boolean: "Boolean",
                    float: "Float"
                  }
                },
                dependence: "inputType",
                required: true,
                cols: 2,
                tooltip: (
                  <HelpTooltip
                    msg={
                      <p className="mb-0">
                        <T i18nKey="modalPropiedadesInicioTipoTooltip" />
                      </p>
                    }
                  />
                )
              },
              {
                name: "Obligatorio",
                label: t("modalPropiedadesInicioRequerido"),
                key: "required",
                type: "switch",
                cols: 2,
                tooltip: (
                  <HelpTooltip
                    msg={t("modalPropiedadesInicioRequeridoTooltip")}
                  />
                )
              }
            ]}
          />
        </Col>
      </Row>
    </>
  );
}
